import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { notification } from "antd";
import axiosHttp from "services/axiosHttp";

export const createPettyCashCommonRequest = createAsyncThunk(
	"createPettyCashCommonRequest",
	async ({ data }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.post(`/petty-cash/common-request`, data);

			notification.success({
				message: "Success",
				description: "Petty cash common request created successfully",
			});
			return response.data;
		} catch (err) {
			if (!err.response) {
				throw err;
			}
			notification.error({
				message: "Error",
				description: err.response?.data?.message || "Failed to create petty cash common request",
			});
			return rejectWithValue(err.response.data);
		}
	}
);

const PettyCashCommonRequestCreateSlice = createSlice({
	name: "PettyCashCommonRequestCreateSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetPettyCashCommonRequestCreateState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(createPettyCashCommonRequest.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(createPettyCashCommonRequest.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(createPettyCashCommonRequest.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetPettyCashCommonRequestCreateState } = PettyCashCommonRequestCreateSlice.actions;
export default PettyCashCommonRequestCreateSlice.reducer;
